"use strict";
export const LogsMock = (mock) => {
  mock.onGet("/v7/loginLogs").reply((config) => {
    let _response = {
      "model": "grid",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_22d3da7029d94585ad5b647ee72a5aca",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620636538e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_2c34bb45be9d4681a333d3a6ffff9d77",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620612323e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_193cf7d92b2b4834bfbeb62d33dae985",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620439643e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_231f4cdd8de2420c8fb0dd85f62109d1",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620386673e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_ea23cb77c4834248b3fdbce8b27512fe",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620378826e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_cc72cf46ae3541289f50a58520f2e344",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620378682e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_58dc445de92b42cdb76e8b79dcfc083d",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620378261e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_7ff5578c92c44554a5cfb85cb19bb40f",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620377792e3
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_6e87092f265744388aea4f3bc43c9d2f",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 162035838e4
          },
          {
            "model": "model.login.log",
            "account": "13672021479",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "id": "login_log_55327dbb24ed4e38a08eff2dc84b0357",
            "login_ip": "60.25.177.180",
            "login_region": "\u5929\u6D25\u5E02\u7EA2\u6865\u533A",
            "operator_name": "\u7BA1\u7406\u5458",
            "login_date": 1620297886e3
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 10448,
        "size": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/virtual_desktops/transfer/log").reply((config) => {
    let _response = {
      "model": "grid",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "model": "model.manage.log",
            "guid": "virtual_desktop_dca352b2dd0d459db7165c737ff7a61b",
            "name": "\u8DE8\u5883\u536B\u58EB",
            "createdTime": 1604392495e3,
            "ip": "39.98.60.59",
            "vdName": "\u8D75\u601D\u4EAE",
            "comment": "\u6B64VD\u8F6C\u79FB\u7ED9\u8D26\u53F7\uFF1A13106142369"
          },
          {
            "model": "model.manage.log",
            "guid": "virtual_desktop_838881b4ba1f43048938463c4337f488",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "createdTime": 1604283396e3,
            "ip": "47.115.189.193",
            "vdName": "18-\u6DF1\u5733(\u963F\u91CC)Win7-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668",
            "comment": "\u6B64VD\u8F6C\u79FB\u7ED9\u8D26\u53F7\uFF1A15822712946"
          },
          {
            "model": "model.manage.log",
            "guid": "virtual_desktop_f4a69f0e9d2d45c5b4b97eca23818701",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "createdTime": 1603095294e3,
            "ip": "127.0.0.1",
            "vdName": "22-\u672C\u5730\u672C\u673A(\u672C\u673AIP)Win7-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668",
            "comment": "\u6B64VD\u8F6C\u79FB\u7ED9\u8D26\u53F7\uFF1A15822594506_del1"
          },
          {
            "model": "model.manage.log",
            "guid": "virtual_desktop_dca352b2dd0d459db7165c737ff7a61b",
            "name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "createdTime": 1603086804e3,
            "ip": "39.98.60.59",
            "vdName": "\u8D75\u601D\u4EAE",
            "comment": "\u6B64VD\u8F6C\u79FB\u7ED9\u8D26\u53F7\uFF1A15822594506_del1"
          }
        ],
        "total": 4
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 4,
        "size": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/client/vd_operation_logs").reply((config) => {
    let _response = {
      "model": "grid",
      "page": {
        "current": 1,
        "model": "page",
        "size": 10,
        "total": 50
      },
      "result": {
        "datas": [
          {
            "created_time": 1618556671714,
            "description": "https://translate.google.cn/",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618556671334,
            "description": "https://translate.google.cn/",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555917773,
            "description": "https://translate.google.cn/",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555917677,
            "description": "https://translate.google.cn/",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555917587,
            "description": "https://www.baidu.com/link?url=uTaqbAGZPTWaGNsrQgZ45wmoRhwX_uYasadcTGb1QRqH9_4gbSxawoE14eGYROO8",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555917202,
            "description": "http://www.baidu.com/link?url=uTaqbAGZPTWaGNsrQgZ45wmoRhwX_uYasadcTGb1QRqH9_4gbSxawoE14eGYROO8",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "6 2-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555917092,
            "description": "https://www.baidu.com/link?url=uTaqbAGZPTWaGNsrQgZ45wmoRhwX_uYasadcTGb1QRqH9_4gbSxawoE14eGYROO8",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555917078,
            "description": "http://www.baidu.com/link?url=uTaqbAGZPTWaGNsrQgZ45wmoRhwX_uYasadcTGb1QRqH9_4gbSxawoE14eGYROO8",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555910950,
            "description": "https://www.baidu.com/s?wd=%E8%B0%B7%E6%AD%8C%E7%BF%BB%E8%AF%91&t=1123",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          },
          {
            "created_time": 1618555910757,
            "description": "https://www.baidu.com/s?wd=%E8%B0%B7%E6%AD%8C%E7%BF%BB%E8%AF%91&t=1123",
            "model": "vd_operation_log",
            "operator_account": "136720214790079",
            "operator_ip": "47.252.16.195",
            "operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "vd_name": "62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"
          }
        ],
        "model": "data.set",
        "total": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/client/risk_event_logs").reply((config) => {
    let _response = {
      "model": "grid",
      "page": {
        "current": 1,
        "model": "page",
        "size": 10,
        "total": 20
      },
      "result": {
        "datas": [
          {
            "guid": "fiOF2XgBYEyJaTXDIW5T",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 1,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618557083885,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "fSOF2XgBYEyJaTXDIW5T",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618557083884,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "IiOF2XgBYEyJaTXDGW5M",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://helium10.com/chrome/welcome/new/?bv=78&ev=5.2.0"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618557081828,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "qSBr2XgBYEyJaTXDpvWz",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618555414093,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc ": "\u9AD8"
          },
          {
            "guid": "aiBr2XgBYEyJaTXDpPVl",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618555413502,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "_CBr2XgBYEyJaTXDnfTO",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://helium10.com/chrome/welcome/new/?bv=77&ev=5.2.0"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618555411815,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "hh9g2XgBYEyJaTXDXPRP",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u7F51\u5740\uFF08system_ben_risk\uFF09",
            "risk_occur_time": 1618554674153,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "hR9g2XgBYEyJaTXDXPRP",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618554674145,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "dx9g2XgBYEyJaTXDWvRb",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://michromeextension.viral-launch.com/"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u7F51\u5740\uFF08system_ben_risk\uFF09",
            "risk_occur_time": 1618554673652,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          },
          {
            "guid": "jh9g2XgBYEyJaTXDS_Pz",
            "model": "risk_event_log",
            "risk_confirm_status": false,
            "risk_confirm_time": null,
            "risk_description": 'VD:"62-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668"\u8BBF\u95EE\u7F51\u9875"https://helium10.com/chrome/welcome/new/?bv=78&ev=5.2.0"\u65F6\u88AB\u963B\u62E6',
            "risk_event_status": 0,
            "risk_name": "\u8BBF\u95EE\u6709\u98CE\u9669\u7F51\u5740\uFF08un_inspect_risk\uFF09",
            "risk_occur_time": 1618554669964,
            "risk_operator_account": "136720214790079",
            "risk_operator_name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641(0079)",
            "risk_type_desc": "\u9AD8"
          }
        ],
        "model": "data.set",
        "total": 10
      }
    };
    return [200, _response];
  });
  mock.onGet("/v7/shops/login_message_log").reply((config) => {
    let _response = {
      "model": "grid",
      "result": {
        "model": "data.set",
        "datas": [
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611550632e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "\u9A6C\u6765\u897F\u4E9A",
            "operating_information": "\u767B\u5F55 signin.ebay.com.my dingzd1995@gmail.com",
            "login_type": "forced",
            "shop_guid": "shop_9a3848e58eb149f7b605e6326f95ee24"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611546614e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u8377\u5170",
            "operating_information": "\u767B\u5F55 signin.ebay.nl dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_e825b6883ade435ba56967771615e49b"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611546446e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u897F\u73ED\u7259",
            "operating_information": "\u767B\u5F55 signin.ebay.es dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_6567cfd5ba964e3eab9b1b9bd4d1ea6a"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611545673e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u82F1\u56FD",
            "operating_information": "\u767B\u5F55 signin.ebay.co.uk dingzd1995@gmail.com",
            "login_type": "forced",
            "shop_guid": "shop_224ac884ac1d48c6a6e4afc50581d7ae"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611545267e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ ip": "47.242.210.20",
            "login_shop": "eBay\u65B0\u52A0\u62AB",
            "operating_information": "\u767B\u5F55 signin.ebay.com.sg dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_bfbf01fca03c477ea1ca1456d782c672"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611544922e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u4FC4\u7F57\u65AF",
            "operating_information": "\u767B\u5F55 signin.ebay.com dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_fefcb5ac69814a9c91c8d3f1e38e8162"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611544855e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u4FC4\u7F57\u65AF",
            "operating_information": "\u767B\u5F55 signin.ebay.com dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_fefcb5ac69814a9c91c8d3f1e38e8162"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611544584e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u6FB3\u5927\u5229\u4E9A",
            "operating_information": "\u767B\u5F55 signin.ebay.com.au dingzd1995@gmail.com",
            "login_type": "forced",
            "shop_guid": "shop_fa80f27cc7f146afbbf0001f5379c0f2"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 1611544411e3,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u6FB3\u5927\u5229\u4E9A",
            "operating_information": "\u767B\u5F55 signin.ebay.com.au dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_fa80f27cc7f146afbbf0001f5379c0f2"
          },
          {
            "name": null,
            "model": "shop.risk.center.log",
            "account_user_guid": "account_aab33b56853824d06868b73b63a0a1e3a",
            "lastlogin_time": 161154418e4,
            "account_name": "\u7BA1\u7406\u5458(\u4E3B\u8D26\u53F7)",
            "account": "dingzd1995@gmail.com",
            "vd_ip": "47.242.210.20",
            "login_shop": "eBay\u6FB3\u5927\u5229\u4E9A",
            "operating_information": "\u767B\u5F55 signin.ebay.com.au dingzd1995@gmail.com",
            "login_type": "normal",
            "shop_guid": "shop_fa80f27cc7f146afbbf0001f5379c0f2"
          }
        ],
        "total": 10
      },
      "page": {
        "model": "page",
        "current": 1,
        "total": 33,
        "size": 10
      }
    };
    return [200, _response];
  });
};
